import { cardsData } from '@/mocks/home';

const colorMap: Record<string, string> = {
  '热播': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  '新片': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '高分': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30',
  '热映': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  '日漫': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '综艺': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30',
};

export default function SectionCards() {
  return (
    <section
      id="cards"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10 gap-3">
          <div>
            <span className="inline-block text-xs font-medium text-accent-400 bg-accent-500/10 px-3 py-1 rounded-full mb-3">
              编辑精选
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-400 mt-2">每日精选高分影视，告别剧荒</p>
          </div>
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors"
          >
            查看全部专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cardsData.map((card, idx) => {
            const tagClass = colorMap[card.tag] || 'bg-background-300/50 text-foreground-300 border-background-400/30';
            const isWide = idx === 0;

            return (
              <div
                key={card.title}
                className={`group relative bg-background-200/70 rounded-xl overflow-hidden border border-background-300/40 hover:border-background-400/60 transition-all duration-300 cursor-pointer ${
                  isWide ? 'xl:col-span-2' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${isWide ? 'xl:aspect-[2.2/1]' : 'aspect-[16/10]'}`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                  <div className={`absolute top-3 left-3 text-[10px] font-medium px-2 py-0.5 rounded border ${tagClass}`}>
                    {card.tag}
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/80 backdrop-blur-sm rounded-full px-2.5 py-1">
                    <i className="ri-star-fill text-primary-500 text-xs"></i>
                    <span className="text-xs font-semibold text-foreground-100">{card.rating}</span>
                  </div>
                </div>
                <div className="p-4">
                  <span className="text-[11px] text-foreground-500">{card.category}</span>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mt-1 line-clamp-1">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-400 mt-1.5 line-clamp-2 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}